import React, { PureComponent, Fragment, memo } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Articulos from './detalleArticulos.jsx';
import ArticulosSuc from './detalleArticulosSuc.jsx'
import TabGeneral from "./tabGeneral.jsx";
import TabDetalle from "./tabDetalle.jsx";
import { Tabs, Tab } from "react-bootstrap";
import ProgressBar from '../../../components/UI/progressBar/progressBarH.jsx';
import { ReactBingmaps } from '../../../components/UI/ReactBingMap';

class liquidarOrdenInt extends PureComponent {
    state = {
        listaSubOrdenes: [], tabActivo: 'general',
    }

    handleTabClick = (id) => {
        this.setState({ tabActivo: id });
    }

    render() {
        const { Datos, OrdenId, listPagos, listTiempos, columnasPagos, columnasTiempos, ordenUbicacion, articulos, articulosAp, sucApoyo, sucTiempo, bingmapKey, infoboxes, pushPins, directions, center, zoom, boundary, tiemposDetalle, liquidar } = this.props;
        let traslado = null;
        let numTraslado = '';
        if (articulos.length > 0) {
            numTraslado = articulos[0].Mov_Id;
        }
        if (ordenUbicacion.sucFact > 0) {
            traslado = (this.props.sucursal.Id != ordenUbicacion.sucFact ? <div className="row"><div className="col mt-2"><p className="traslado">Número de traslado</p></div><div className="col mt-2"><p className="traslado"><span className="dot"></span>{numTraslado}</p></div></div> : null);
        }
        const { tabActivo } = this.state;

        return (
            <Fragment>
                <section className="monitor-suc">
                    <div className="row no-gutters">
                        <div className="col-6">
                            <div className="consulta-ordenes">
                                <div className="row">
                                    <div className="col-6">
                                        <h1>Consulta de Órdenes</h1>
                                    </div>
                                </div>
                                <div className="row mt-3 mb-4">

                                    <div className="col-7">
                                        <input id='OrdenId' name='OrdenId' type="search" className="form-control" placeholder="Número de Orden" maxLength={10} value={OrdenId} onChange={this.props.onChangeBuscar} onKeyPress={this.props.onKeyPressBuscar} />
                                    </div>
                                    <div className="col-2 text-center">
                                        <button className="btn btn-primary" onClick={this.props.onClickBuscar}>Buscar</button>
                                    </div>
                                    <div className="col-3 text-center">
                                        <button className={` btn  ${liquidar ? 'btn-danger' : 'btn-secondary'}`} onClick={this.props.onClickLiquidar} >Liquidar</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <ProgressBar tiempos={tiemposDetalle} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">

                                        <Tabs defaultActiveKey={"general"} activeKey={tabActivo} id="gralDet" onSelect={this.handleTabClick}>
                                            <Tab eventKey="general" title={"General"}>
                                                <TabGeneral
                                                    Datos={Datos}
                                                    listPagos={listPagos}
                                                    columnasPagos={columnasPagos}
                                                />
                                            </Tab>
                                            <Tab eventKey="detalle" title={'Detalles'}>
                                                <TabDetalle
                                                    Datos={Datos}
                                                    listTiempos={listTiempos}
                                                    columnasTiempos={columnasTiempos}
                                                    sucTiempo={sucTiempo}
                                                />
                                            </Tab>
                                            {
                                                Datos.Instrucciones_Entrega ?
                                                    <Tab eventKey="instr_entrega" title={'Instrucciones de Entrega'}>
                                                        <div className="row">
                                                            <div className="col">
                                                                <p className="break-word">{Datos.Instrucciones_Entrega}</p>
                                                            </div>
                                                        </div>
                                                    </Tab>
                                                    : null
                                            }
                                        </Tabs>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-3">
                            <div className="orden-ubicacion">
                                <div className="row">
                                    <div className="col">
                                        <h6>{ordenUbicacion.Fecha} </h6>
                                        <h5>{`# ${ordenUbicacion.Orden}`}</h5>
                                        <h5>{`${Datos.Factura.value}`}</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <span className="badge badge-warning">{ordenUbicacion.Estado}</span>
                                        <span className="badge badge-secondary">Disponible: <span className="time">{`${ordenUbicacion.Disponible_Positivo == true ? " +" : "-"} ${ordenUbicacion.Disponible}`}</span></span>
                                    </div>
                                </div>
                                <div className="row">
                                    <br></br>
                                    <br></br>
                                    <div className="col">
                                        <label>Teléfono</label>
                                        <p>{ordenUbicacion.Telefono}</p>
                                    </div>
                                    <div className="col">
                                        <label>Nombre</label>
                                        <p>{ordenUbicacion.Nombre}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="map-three">
                                            <ReactBingmaps
                                                className="customClass"
                                                key={bingmapKey}
                                                id="eleven"
                                                bingmapKey={bingmapKey}
                                                infoboxes={infoboxes}
                                                pushPins={pushPins}
                                                directions={directions}
                                                center={center}
                                                zoom={zoom}
                                                boundary={boundary}
                                                infoRoutes={() => { }}
                                                navigationBarMode={'compact'}
                                            >
                                            </ReactBingmaps>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <p>{`${ordenUbicacion.Ubicacion} ${ordenUbicacion.DireccionAdic}`}</p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <label>Localidad</label>
                                        <p>{ordenUbicacion.Localidad}</p>
                                    </div>
                                    <div className="col">
                                        <label>Observaciones</label>
                                        <p>{ordenUbicacion.Observaciones}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-3">
                            <div className="articulos">
                                <h5>Artículos</h5>
                                {traslado}
                                <div className="row">

                                    <div className="col">
                                        <div className="lista">
                                            <Articulos articulos={articulos} />
                                            {
                                                sucApoyo.map(suc => {
                                                    return (
                                                        <ArticulosSuc
                                                            articulos={articulosAp}
                                                            sucursalArt={suc}
                                                            sucFact={ordenUbicacion.sucFact}
                                                        />
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </Fragment >


        );
    }

}
const mapStateToProps = state => {
    return {
        token: state.usuario.token,
        usuarioLogueado: state.usuario.usuarioLogueado,
        empresa: state.parametros.empresa,
        sucursal: state.parametros.sucursal,
        callCenter: state.parametros.callCenter
    };
};
export default connect(mapStateToProps)(withRouter(memo(liquidarOrdenInt)));






